module.exports = __webpack_public_path__ + "img/lr1.c4c8dc82.png";